export const TopOffersTabsSlider = () => {
  const tabContainers = document.querySelectorAll(".top-offers-tabs");

  tabContainers.forEach((container) => {
    const tabs = container.querySelectorAll(".tab");
    const tabContents = container.querySelectorAll(".tab-content");

    const splides = [];
    tabContents.forEach((content) => {
      const slider = content.querySelector(".splide-top-offers");
      if (slider) {
        const splideInstance = new Splide(slider, {
          type: "slide",
          perPage: 3,
          perMove: 1,
          arrows: true,
          pagination: false,
          gap: "24px",
          drag: true,
          breakpoints: {
            1440: {
              gap: "24px",
              perPage: 3,
            },
            1100: {
              gap: "16px",
              perPage: 2,
            },
            576: {
              perPage: 1,
            },
          },
        });
        splideInstance.mount();
        splides.push(splideInstance);
      }
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const targetId = tab.dataset.tab;

        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        tabContents.forEach((content) => {
          content.classList.toggle("active", content.id === targetId);
        });
      });
    });
  });
};
